import { adminChatMessageSchema } from "../schemas/chat-message";
import { messageReportSchema, type UpdateReportStatus } from "../schemas/report";
import { fetchApi, paginatedSchema } from "./internal";

export interface AdminChatMessageFilters {
	roomId?: string;
	gameId?: string;
	senderId?: string;
	search?: string;
	limit?: number;
	offset?: number;
}

export const chat = {
	listMessages: (filters: AdminChatMessageFilters = {}) => {
		const params = new URLSearchParams();
		if (filters.roomId) params.set("room_id", filters.roomId);
		if (filters.gameId) params.set("game_id", filters.gameId);
		if (filters.senderId) params.set("sender_id", filters.senderId);
		if (filters.search) params.set("search", filters.search);
		if (filters.limit) params.set("limit", String(filters.limit));
		if (filters.offset) params.set("offset", String(filters.offset));
		const qs = params.toString();
		return fetchApi(
			`/admin/messages${qs ? `?${qs}` : ""}`,
			paginatedSchema(adminChatMessageSchema),
		);
	},
	reports: {
		list: (status: string = "open", limit = 50, offset = 0) =>
			fetchApi(
				`/admin/messages/reports?status=${status}&limit=${limit}&offset=${offset}`,
				paginatedSchema(messageReportSchema),
			),
		updateStatus: (id: string, body: UpdateReportStatus) =>
			fetchApi(`/admin/messages/reports/${id}`, messageReportSchema, {
				method: "PATCH",
				body: JSON.stringify(body),
			}),
	},
};
